class FixedNav {
  constructor() {
  

      jQuery(window).scroll( function(){
        if (jQuery(this).scrollTop() > 5){  
            jQuery('.header').addClass("sticky");
            jQuery('body').addClass("body-with-sticky-header");
        }
        else{
            jQuery('.header').removeClass("sticky");
            jQuery('body').removeClass("body-with-sticky-header");
        }
      });
      
      jQuery(window).on('load' , function() {
        if (jQuery(window).scrollTop() > 5){  
          jQuery('.header').addClass("sticky");
          jQuery('body').addClass("body-with-sticky-header");
        }
      });

}
}

export default FixedNav;  
